export function EmptySlot(): JSX.Element {
  // Leere Slots bleiben komplett leer (kein Text, kein Rahmen).
  return <div className="h-full w-full" />;
}
